import myAxios from './myAxios';

export {
    getUser
};

function getUser(){
    return myAxios.get('/users/getprofile');
}
